// extracted by mini-css-extract-plugin
module.exports = {"Main":"style_Main__-d1BZ","Main-content":"style_Main-content__25wg2"};